/* RESON V2 - global.js: money helper, drawers, PDP gallery */
(function () {
  var R = (window.RESON = window.RESON || {});

  R.money = function (cents) {
    var n = (cents || 0) / 100;
    var hasCents = Math.round(cents) % 100 !== 0;
    var s = n.toLocaleString('en-AU', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0
    });
    return (R.moneyPrefix || '') + '$' + s;
  };

  function open(cls) { document.body.classList.add(cls); }
  function close(cls) { document.body.classList.remove(cls); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-menu],[data-close-menu],[data-open-cart],[data-close-cart],[data-pdp-thumb]');
    if (!t) return;
    if (t.hasAttribute('data-open-menu')) { e.preventDefault(); open('menu-open'); }
    if (t.hasAttribute('data-close-menu')) { e.preventDefault(); close('menu-open'); }
    if (t.hasAttribute('data-open-cart')) { e.preventDefault(); open('cart-open'); }
    if (t.hasAttribute('data-close-cart')) { e.preventDefault(); close('cart-open'); }
    if (t.hasAttribute('data-pdp-thumb')) {
      e.preventDefault();
      var src = t.getAttribute('data-src');
      var main = document.querySelector('[data-pdp-main-image]');
      if (main && src) main.src = src;
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (el) { el.classList.remove('is-active'); });
      t.classList.add('is-active');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close('menu-open'); close('cart-open'); }
  });

  // Reusable carousel scroll-progress bars. Any [data-scrollbar] is paired with
  // the nearest preceding [data-scrollbar-track]; the thumb sizes to the visible
  // fraction and moves with scroll. Hidden automatically when nothing overflows.
  function initScrollbars(scope) {
    (scope || document).querySelectorAll('[data-scrollbar]').forEach(function (bar) {
      if (bar.__sb) return;
      var track = bar.previousElementSibling;
      while (track && !track.hasAttribute('data-scrollbar-track')) track = track.previousElementSibling;
      if (!track) track = (bar.parentElement || document).querySelector('[data-scrollbar-track]');
      var thumb = bar.querySelector('.scrollbar__thumb');
      if (!track || !thumb) return;
      bar.__sb = true;
      function update() {
        var sw = track.scrollWidth, cw = track.clientWidth, max = sw - cw;
        if (max <= 2) { bar.setAttribute('hidden', ''); return; }
        bar.removeAttribute('hidden');
        var w = Math.max(cw / sw * 100, 14);
        thumb.style.width = w + '%';
        thumb.style.left = (track.scrollLeft / max) * (100 - w) + '%';
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (window.ResizeObserver) new ResizeObserver(update).observe(track);
      update();
    });
  }
  R.initScrollbars = initScrollbars;
  if (document.readyState !== 'loading') initScrollbars();
  else document.addEventListener('DOMContentLoaded', function () { initScrollbars(); });
  document.addEventListener('shopify:section:load', function (e) { initScrollbars(e.target); });

  document.documentElement.classList.remove('no-js');
})();
